import React from 'react';
import './projectName.css';

export interface ProjectNameProps {
  name: string;
}

export const ProjectName: React.FC<ProjectNameProps> = ({ name }) => {
  return (
    <div className="project-name">
      {name}
    </div>
  );
};
